// import { transparentize } from 'polished';
import { UnderlinedHeader } from '../../common-elements';
import styled from '../../styled-components';
import { ResponseTitle } from './ResponseTitle';
export const StyledResponseTitle = styled(ResponseTitle).withConfig({
  displayName: "styledelements__StyledResponseTitle",
  componentId: "sc-1ab6qnp-0"
})(["padding:12px 10px;margin-bottom:8px;line-height:1.5em;cursor:pointer;transition:0.25s background-color;color:", ";background-color:", ";border-radius:23px;border:1px solid ", ";&:hover{background-color:", ";}span{p{padding:0;}ul{padding:1em 0.5em 0.5em 1.875em;}}", ";"], props => props.theme.colors.responses[props.type].color, props => props.theme.colors.responses[props.type].backgroundColor, props => props.theme.colors.responses[props.type].color, props => props.theme.colors.responses[props.type].backgroundColorHover, props => props.empty && `
cursor: default;
&::before {
  content: "—";
  font-weight: 400;
  width: 1.5em;
  text-align: center;
  display: inline-block;
}
` || '');
export const ResponseDetailsWrap = styled.div.withConfig({
  displayName: "styledelements__ResponseDetailsWrap",
  componentId: "sc-1ab6qnp-1"
})(["padding:0;position:relative;top:-4px;"]);
export const HeadersCaption = styled(UnderlinedHeader.withComponent('caption')).withConfig({
  displayName: "styledelements__HeadersCaption",
  componentId: "sc-1ab6qnp-2"
})(["text-align:left;margin-top:1em;caption-side:top;"]);